import React from 'react'
import classnames from 'classnames'

const FailedIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    className={classnames('icon--failed', {
      [className]: !!className,
    })}
    xmlns="http://www.w3.org/2000/svg"
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="currentColor"
  >
    <path
      d="M59.7487 10.2512C53.1381 3.64055 44.3487 0 35 0C25.6513 0 16.8619 3.64055 10.2513 10.2513C3.64068 16.8619 0 25.6512 0 35.0001C0 44.349 3.64055 53.1383 10.2512 59.749C16.8618 66.3593 25.651 70 34.9999 70C44.3487 70 53.1381 66.3595 59.7487 59.7488C66.3593 53.1381 70 44.3488 70 35C70 25.6512 66.3593 16.8619 59.7487 10.2512ZM56.8485 56.8486C51.0125 62.6845 43.2532 65.8984 34.9999 65.8984C26.7466 65.8984 18.9872 62.6845 13.1514 56.8486C7.31541 51.0126 4.10156 43.2534 4.10156 35.0001C4.10156 26.7468 7.31568 18.9875 13.1515 13.1515C18.9875 7.31555 26.7467 4.10156 35 4.10156C43.2533 4.10156 51.0125 7.31555 56.8486 13.1514C68.8956 25.1988 68.8956 44.8012 56.8485 56.8486Z"
      fill="currentColor"
    />
    <path
      d="M46.5317 44.2701L36.7616 34.5L46.5317 24.73C47.1561 24.1054 47.1561 23.0929 46.5315 22.4685C45.9071 21.844 44.8945 21.844 44.27 22.4685L34.5 32.2385L24.73 22.4684C24.1055 21.8439 23.0929 21.8439 22.4684 22.4684C21.8439 23.0929 21.8439 24.1054 22.4684 24.73L32.2385 34.5L22.4684 44.2701C21.8439 44.8946 21.8439 45.9071 22.4684 46.5317C22.7807 46.8439 23.19 47 23.5991 47C24.0084 47 24.4177 46.8439 24.73 46.5317L34.5 36.7616L44.2701 46.5317C44.5824 46.8439 44.9916 47 45.4009 47C45.8102 47 46.2195 46.8439 46.5317 46.5317C47.1562 45.9071 47.1562 44.8946 46.5317 44.2701Z"
      fill="currentColor"
    />
  </svg>
)

export default FailedIcon
